module.exports = __webpack_public_path__ + "static/fonts/TTNorms-Medium.df89539.ttf";